module.exports = __webpack_public_path__ + "img/z (4).b822e170.png";